import classes from './AdminFooter.tsx.module.css';
import { Container, Group, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import Logo from '../../components/icons/Logo';
import { isDtiHosted, isRevProHosted, isTKTEdgeHosted, isVictoryLiveHosted } from '../../utils/whitelabel-consts';

interface AdminFooterProps {
  links: { link: string; label: string; links: { link: string; label: string }[]; disabled?: boolean }[];
}

export function AdminFooter({ links }: AdminFooterProps) {
  const items = links.map((link) =>
    link.disabled ? (
      <Text key={link.label} size="sm" c="var(--colors-gray-4)">
        {link.label}
      </Text>
    ) : (
      <Link to={link.link} key={link.label}>
        <Text c="dimmed" size="sm">
          {link.label}
        </Text>
      </Link>
    ),
  );

  return (
    <Container className={classes.inner} py="xl" h="auto" fluid>
      <Group py="xl" justify="space-between" w="100%">
        <Group>
          <Logo
            size={isDtiHosted || isVictoryLiveHosted ? 100 : isRevProHosted ? 68 : isTKTEdgeHosted ? 60 : 48}
            brand={isDtiHosted ? 'dti' : isVictoryLiveHosted ? 'victorylive' : isRevProHosted ? 'revpro' : isTKTEdgeHosted ? 'tktedge' : 'bn'}
            variant={isDtiHosted || isVictoryLiveHosted ? 'hover' : isRevProHosted ? 'hover' : isTKTEdgeHosted ? 'hover' : 'default'}
          />
          {!isDtiHosted && !isVictoryLiveHosted && !isRevProHosted && !isTKTEdgeHosted && (
            <Text size="sm" fw={600} c="dimmed">
              Broker Nerds
            </Text>
          )}
        </Group>
        <Group gap={16} className={classes.links}>
          {items}
        </Group>
      </Group>
    </Container>
  );
}
